import { mapGetters} from 'vuex'

export default {
  name: 'Loader',
  //---components
  //---data
  data () {
    return {}
  },
  //---hooks
  computed: {
    ...mapGetters({
      isLoaderActive: 'APP/isLoaderActive',
    }),
  },
  //---methods
}